import { KeyValueModel } from "model/api";
import { EnumTipoPropagandaDestaque } from "model/enums/enum-tipo-propaganda-destaque";

export const PropagandaDestaqueMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPropagandaDestaque.NaoInformado, "Não Informado"),
    new KeyValueModel(EnumTipoPropagandaDestaque.Alto, "Alto"),
    new KeyValueModel(EnumTipoPropagandaDestaque.Medio, "Médio"),
    new KeyValueModel(EnumTipoPropagandaDestaque.Baixo, "Baixo"),
];